import { mockKernel } from '@/api/mock/mockKernel';
import type { BaseApi } from './baseApi';
import { baseHttpApi } from './baseHttpApi';
import { baseMock } from './mock/baseMock';

/**
 * Base's calls use Django by default. Only an explicit VITE_API_MODE=mock selects the in-memory test/prototype implementation.
 */
export const baseApi: BaseApi = new Proxy({} as BaseApi, {
  get(_target, property: string) {
    const member = property as keyof BaseApi;
    // Use the env value here so the production bundler can remove the unused live/mock implementation.
    return (import.meta.env.VITE_API_MODE === 'mock' ? baseMock(mockKernel()).api : baseHttpApi)[member];
  },
});
